import { useState } from 'react';
import './App.css';
import TaskModal from './TaskModal';
import { Button, ThemeProvider, createTheme, createStyles } from '@mui/material';
import TaskList from './TasksList';

function App() {


  const theme = createTheme({
    typography: {
      fontFamily: 'Poppins, sans-serif', // Set font family to Poppins
    },
    palette: {
      primary: {
        main: '#FFA500', // Set primary color to your desired hex color
      },
      secondary: {
        main: '#FFF', // Set secondary color to your desired hex color
      },
      // You can override more colors as needed (e.g., text, background, etc.)
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            ...createStyles({
              color: '#FFF', // Set the default button text color to white
            }),
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            backgroundColor: '#FFA500', // Set default background color to primary.main
            // You can add more styles as needed
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{width:'750px', margin:'0 auto', textAlign:'center', height:'100vh', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
        <TaskList/>
      </div>
    </ThemeProvider>
  );
}

export default App;
